import { Log } from '@/types/logs'
import { getLogCommonInformation } from '@/helpers/logInformation'
import styles from '../MechanicalInformationModal.module.scss'

interface Props {
    log: Log
}

export const LogInformation = ({ log }: Props) => {
    const { routes, trip, run, fleet } = getLogCommonInformation(log)
    return (
        <div className={styles.informationContainer}>
            <div className={styles.informationWrapper}>
                <span className={styles.label}>Route</span>
                <span className={styles.textBold}>{routes || '-'}</span>
            </div>
            <div className={styles.informationWrapper}>
                <span className={styles.label}>Trip</span>
                <span className={styles.text}>{trip || '-'}</span>
            </div>
            <div className={styles.informationWrapper}>
                <span className={styles.label}>Run</span>
                <span className={styles.text}>{run || '-'}</span>
            </div>
            <div className={styles.informationWrapper}>
                <span className={styles.label}>Fleet</span>
                <span className={styles.text}>{fleet || '-'}</span>
            </div>
        </div>
    )
}
